<script setup>
import { ref, inject } from 'vue';
import { CdrToast, CdrButton, IconInformationFill } from '@rei/cedar';
import EmailTemplate from './EmailTemplate.vue';
import cms from './data';

const opened = ref(false);

const metricsClick = inject('metricsClick');

const open = () => {
  metricsClick('WheresMyReservationId', 'open');
  opened.value = true;
};

const close = () => {
  metricsClick('WheresMyReservationId', 'close');
  opened.value = false;
};
</script>

<template>
  <div class="wheres-my-reservation-id">
    <CdrButton
      class="wheres-my-reservation-id__button"
      modifier="link"
      size="large"
      data-ui="wheres-my-reservation-id-button"
      :title="cms.reservationLookup.popover.name"
      @click="open"
    >
      {{ cms.reservationLookup.popover.name }}
    </CdrButton>
    <CdrToast
      class="wheres-my-reservation-id__toast"
      type="info"
      data-ui="wheres-my-reservation-id-toast"
      :open="opened"
      :auto-dismiss="false"
      @closed="close"
    >
      <template #icon-left>
        <IconInformationFill />
      </template>
      <div class="wheres-my-reservation-id__content">
        <span class="wheres-my-reservation-id__body">
          {{ cms.reservationLookup.popover.body }}
        </span>
        <EmailTemplate />
      </div>
    </CdrToast>
  </div>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.wheres-my-reservation-id {
  &__button {
    padding: 0;
  }

  &__toast {
    margin-top: $cdr-space-one-x;
  }

  &__content {
    @include cdr-text-body-300;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $cdr-space-one-and-a-half-x;
    padding: $cdr-space-one-and-a-half-x $cdr-space-three-quarter-x;
  }
}
</style>
